// extracted by mini-css-extract-plugin
module.exports = {"imgBox":"singleProduct_imgBox__4ft_C","description":"singleProduct_description__lrRk-","price":"singleProduct_price__36xB1","actionBox":"singleProduct_actionBox__28YmC"};